/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Route, Switch, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import cx from "classnames";
import FantomOld from "./views/FantomOld";
import Fantom from "./views/Fantom";
import BSC from "./views/BSC";
import Referrals from "./views/Referrals";
import Trading from "./views/Trading";
import "./App.css";
import logoIcon from "./img/logo.svg";
import darkLogoIcon from "./img/logo.svg";
import lightLogoIcon from "./img/logo.svg";
import { FaSun, FaMoon, FaTimes } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { RiMenuLine } from "react-icons/ri";

export const themeIcon = (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      d="M10.103 -0.000976562H10.9239C11.5444 0.116531 12.0439 0.434541 12.4728 0.89389C12.8832 1.33269 13.3219 1.74479 13.7422 2.17415C13.7877 2.22409 13.8436 2.26345 13.9059 2.28943C13.9682 2.31541 14.0355 2.32739 14.1029 2.32453C14.8417 2.31877 15.5776 2.31549 16.3147 2.32453C17.4975 2.33808 18.5601 3.35169 18.6405 4.53129C18.6935 5.30947 18.6549 6.08847 18.6627 6.86747C18.6599 6.9418 18.6731 7.01585 18.7015 7.08462C18.7298 7.15338 18.7725 7.21524 18.8268 7.26601C19.2323 7.66168 19.6202 8.07665 20.0331 8.4641C20.5034 8.90537 20.8613 9.40621 21 10.0459V10.8677C20.8797 11.4811 20.5588 11.9737 20.111 12.4006C19.6809 12.8115 19.273 13.2433 18.8465 13.6574C18.7843 13.7144 18.7355 13.7845 18.7035 13.8627C18.6716 13.9408 18.6574 14.0251 18.6619 14.1094C18.6697 14.738 18.6684 15.3666 18.6619 15.9953C18.6643 16.2002 18.6485 16.4049 18.6147 16.6071C18.384 17.8056 17.3965 18.6203 16.1772 18.6269C15.4943 18.6302 14.8117 18.6318 14.1292 18.6248C14.0517 18.6208 13.9742 18.6339 13.9023 18.6633C13.8305 18.6927 13.766 18.7377 13.7135 18.7949C13.2407 19.2786 12.7631 19.758 12.2807 20.2329C11.2321 21.2601 9.77716 21.2527 8.73265 20.2206C8.4117 19.9038 8.06161 19.6097 7.78417 19.258C7.37827 18.7431 6.89439 18.5628 6.24347 18.6154C5.64221 18.6639 5.02945 18.6737 4.4245 18.5903C3.35208 18.4424 2.46353 17.4892 2.38637 16.409C2.33261 15.6514 2.36872 14.8925 2.36626 14.1345C2.36978 14.04 2.35261 13.946 2.31596 13.8589C2.2793 13.7718 2.22405 13.6938 2.15407 13.6303C1.69318 13.1837 1.24213 12.7264 0.790669 12.2699C-0.264923 11.2017 -0.263281 9.74025 0.793953 8.67364C1.2606 8.2032 1.72724 7.73276 2.20045 7.26889C2.25523 7.21849 2.29831 7.15669 2.32668 7.08784C2.35504 7.01899 2.36799 6.94475 2.36462 6.87035C2.35928 6.20064 2.36462 5.53092 2.36462 4.8608C2.36462 3.19762 3.7116 2.25755 4.93998 2.31877C5.60732 2.35205 6.27753 2.32206 6.94651 2.32658C7.00732 2.32922 7.06797 2.31857 7.12424 2.29537C7.18052 2.27216 7.23107 2.23697 7.27238 2.19223C7.6988 1.75876 8.14205 1.34173 8.55657 0.897587C8.983 0.434952 9.48288 0.117353 10.103 -0.000976562ZM11.1521 10.4761V8.32358C11.1521 7.54294 11.1545 6.7664 11.1521 5.98781C11.1521 5.50504 10.8943 5.25523 10.4199 5.25564C10.1812 5.254 9.94269 5.26924 9.70615 5.30125C8.38174 5.49107 7.26089 6.06094 6.42282 7.11687C5.43782 8.35357 5.15463 9.78133 5.36189 11.3225C5.70295 13.853 7.77514 15.6703 10.3304 15.6904C10.9177 15.6949 11.1537 15.464 11.1541 14.8806C11.1533 13.4122 11.1521 11.9437 11.1504 10.4753L11.1521 10.4761Z"
      fill="currentColor"
    />
  </svg>
);

function AppHeaderLinks({ mode, small, clickCloseIcon }) {
  return (
    <div className="App-header-links">
      {small && (
        <div className="App-header-links-header">
          <div
            className="App-header-menu-icon-block"
            onClick={() => clickCloseIcon()}
          >
            <FiX className="App-header-menu-icon" />
          </div>
          <NavLink
            exact
            activeClassName="active"
            className="App-header-link-main"
            to="/"
          >
            <img src={logoIcon} alt="Morphex Logo" />
          </NavLink>
        </div>
      )}
      <div className="App-header-link-container">
        <NavLink to="/" exact className="nav-link" activeClassName="active">
          Fantom
        </NavLink>
      </div>
      <div className="App-header-link-container">
        <NavLink to="/bsc" exact className="nav-link">
          BNB Chain
        </NavLink>
      </div>
      <div className="App-header-link-container">
        <NavLink to="/ftm-old" exact className="nav-link">
          Fantom (Old)
        </NavLink>
      </div>
    </div>
  );
}

const App = () => {
  const [mode, setMode] = useState(null);
  const [isDrawerVisible, setIsDrawerVisible] = useState(undefined);

  const slideVariants = {
    hidden: { x: "-100%" },
    visible: { x: 0 },
  };

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  useEffect(() => {
    const savedMode = window.localStorage.getItem("mode");
    const targetMode = savedMode == "light" ? "light" : "dark";
    document.querySelector("body").style.backgroundColor =
      targetMode == "dark" ? "#101124" : "#f6f9ff";
    setMode(targetMode);
  }, []);

  const switchMode = () => {
    const targetMode = mode == "dark" ? "light" : "dark";
    window.localStorage.setItem("mode", targetMode);
    document.querySelector("body").style.backgroundColor =
      targetMode == "dark" ? "#101124" : "#f6f9ff";
    setMode(targetMode);
  };

  return (
    <div className="wrapper">
      <Switch>
        {mode && (
          <div className={cx("App", mode)}>
            {isDrawerVisible && (
              <AnimatePresence>
                {isDrawerVisible && (
                  <motion.div
                    className="App-header-backdrop"
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={fadeVariants}
                    transition={{ duration: 0.2 }}
                    onClick={() => setIsDrawerVisible(!isDrawerVisible)}
                  ></motion.div>
                )}
              </AnimatePresence>
            )}
            <div className="nav">
              <div className="nav-left">
                <div
                  className="App-header-menu-icon-block"
                  onClick={() => setIsDrawerVisible(!isDrawerVisible)}
                >
                  {!isDrawerVisible && (
                    <RiMenuLine className="App-header-menu-icon" />
                  )}
                  {isDrawerVisible && (
                    <FaTimes className="App-header-menu-icon" />
                  )}
                </div>
                <a
                  href="https://www.morphex.trade/"
                  target="_blank"
                  className="nav-logo"
                  rel="noreferrer"
                >
                  <img
                    width="87"
                    src={mode == "dark" ? darkLogoIcon : lightLogoIcon}
                  />
                </a>
                <NavLink
                  to="/"
                  exact
                  className="nav-link"
                  activeClassName="active"
                >
                  Fantom
                </NavLink>
                <NavLink
                  to="/bsc"
                  exact
                  className="nav-link"
                >
                  BNB Chain
                </NavLink>
                <NavLink
                  to="/ftm-old"
                  exact
                  className="nav-link"
                >
                  Fantom (Old)
                </NavLink>
              </div>
              <div className="nav-right">
                <a
                  href="https://www.morphex.trade/"
                  target="_blank"
                  className="nav-link"
                  rel="noreferrer"
                >
                  Trade
                </a>
                <a
                  href="https://docs.morphex.trade/"
                  target="_blank"
                  className="nav-link"
                  rel="noreferrer"
                >
                  Docs
                </a>
                <div className="modeselect" onClick={() => switchMode()}>
                  {/* {mode == "dark" ? <FaSun /> : <FaMoon />} */}
                  {themeIcon}
                </div>
              </div>
            </div>
            <AnimatePresence>
              {isDrawerVisible && (
                <motion.div
                  onClick={() => setIsDrawerVisible(false)}
                  className="App-header-links-container App-header-drawer"
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={slideVariants}
                  transition={{ duration: 0.2 }}
                >
                  <AppHeaderLinks
                    mode={mode}
                    small
                    clickCloseIcon={() => setIsDrawerVisible(false)}
                  />
                </motion.div>
              )}
            </AnimatePresence>
            <div className="content">
              <Route
                exact
                path="/"
                render={(props) => <Fantom {...props} mode={mode} />}
              />
              <Route
                exact
                path="/bsc"
                render={(props) => <BSC {...props} mode={mode} />}
              />
              <Route
                exact
                path="/ftm-old"
                render={(props) => <FantomOld {...props} mode={mode} />}
              />
              {/* <Route
                exact
                path="/referrals/:chainName"
                render={(props) => <Referrals {...props} mode={mode} />}
              />
              <Route exact path="/trading" component={Trading} /> */}
            </div>
          </div>
        )}
      </Switch>
    </div>
  );
};

export default App;
